import { string } from 'prop-types'
import React from 'react'
import { useTranslation } from '@mc/i18n'

import { Truncate } from './Truncate'

export const Description = ({
  description,
  textClassName = '',
}: {
  description: string
  textClassName?: string
}) => {
  const { t } = useTranslation('@mc/next')

  const truncateProps = {
    text: description,
    textStyle: textClassName,
    showMoreText: t('sessions.campHero.descriptionShowMore'),
    showLessText: t('sessions.campHero.descriptionShowLess'),
  }

  return (
    <div className='row'>
      <div className='col-12'>
        <div className='d-block d-md-none'>
          <Truncate maxLine={2} {...truncateProps} />
        </div>
        <div className='d-none d-md-block'>
          <Truncate maxLine={3} {...truncateProps} />
        </div>
      </div>
    </div>
  )
}

Description.propTypes = {
  description: string.isRequired,
  textClassName: string,
}
